import React, { useState, useEffect } from 'react';
import { TextField, Button, Grid } from '@material-ui/core';
import Loader from 'react-loader-spinner';
import { MainTemplate } from 'shared/MainTemplate/MainTemplate';
import handleNotification from 'helpers/handleNotification';
import { ILang } from 'api/services/langs/types';
import { IFile } from 'api/services/file/types';
import getImageByImageSize from 'helpers/getImageByImageSize';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { langServices } from 'api/services';
import { useDispatch, useSelector } from 'react-redux';
import redirect from 'helpers/redirect';
import { AppState } from 'store/store';
import { FileUploader } from 'shared/FileUploader/FileUploader';
import { useHistory } from 'react-router';
import * as langActions from 'store/ducks/langs/actions';

import './CreateLangPage.sass';

export const CreateLangPage: React.FC = () => {
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [file, setFile] = useState<IFile>();
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const history = useHistory();
  const { user } = useSelector((state: AppState) => state.userReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user) redirect(user?.role);
  }, [user?.role]);

  const createLang = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || !file || !code.trim()) {
      setHasError(true);
      handleNotification('Заполните поля');
      return;
    }
    setLoading(true);
    const data: ILang = {
      title: name,
      code,
      fileId: file.id,
    };

    try {
      await langServices.createLang(data);
      handleNotification('Язык сохранен', 'success');
      dispatch(langActions.getLangs());
      history.push('/languages');
    } catch (e: any) {
      handleNotification(
        e?.response?.data?.message || 'Ошибка попробуйте позже',
      );
      setLoading(false);
    }
  };

  const selectFile = (file: IFile) => {
    setFile(file);
  };

  return (
    <MainTemplate title="Создать язык" hideBtn>
      <form onSubmit={createLang}>
        <TextField
          variant="outlined"
          label="Название"
          className="form-field"
          value={name}
          required
          autoFocus
          error={hasError && !name.trim()}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          variant="outlined"
          label="Код языка"
          required
          className="form-field"
          value={code}
          error={hasError && !code.trim()}
          onChange={(e) => setCode(e.target.value)}
        />
        {file && (
          <div className="page-form__file">
            <img
              className="page-form__file-icon"
              src={getImageByImageSize({ file, imageSize: '100x100' })}
            />
            <div className="page-form__file-delete">
              <DeleteForeverIcon
                color="secondary"
                onClick={() => setFile(undefined)}
              />
            </div>
          </div>
        )}
        <Grid
          container
          justifyContent="space-between"
          className="page-form__actions"
        >
          <FileUploader
            selectFile={selectFile}
            text={file ? 'Выбрать другую иконку' : 'Выбрать иконку для языка'}
            width={40}
            height={40}
            image
          />
          <Button
            className="action-button"
            size="large"
            color="primary"
            type="submit"
            variant="contained"
            disabled={loading}
          >
            {loading ? (
              <Loader height={10} type="ThreeDots" color="#fff" />
            ) : (
              'Сохранить'
            )}
          </Button>
        </Grid>
      </form>
    </MainTemplate>
  );
};
